import { useContext } from "react";
import { CommonFormContext } from "src/context/Modal/Form/CommonForm.context";

export const useCommonForm = () => {
  const value = useContext(CommonFormContext);
  if (!value) {
    throw new Error(`cannot find useCommonForm`);
  }

  return value;
};
